module.exports = __webpack_public_path__ + "img/9788992711913.2fc7bbd1.jpg";